<template>
    <div class="home content-wrapper">
        <div class="title-wrapper">
            <span class="bracket-wrapper">
                <img class="bracket" src="~@/assets/celtic_bracket.png" />
            </span>
            <h1 class="title">
                War Chest Online
            </h1>
            <span class="bracket-wrapper left">
                <img class="bracket flipped" src="~@/assets/celtic_bracket.png" />
            </span>
        </div>
        <div class="content">
            <p>
                War Chest is a war-themed abstract strategy game where two or four players
                compete to control bases on a board using military units with unique abilities.
            </p>
            <p>
                The game was designed by Trevor Benjamin and David Thompson and published by
                Alderac Entertainment Group in 2018.
            </p>
            <p>
                <strong>War Chest Online</strong> is an unofficial fan-made adaptation of the game.
                It's completely free to play. All you need to do is
                    <router-link :to="{ name: 'login', params: { action: 'signUp' }}" class="link">
                        create an account
                    </router-link>
                 and you can start playing.
            </p>
            <p>
                Already have an account? Click <router-link to="/rooms" class="link">
                        here
                    </router-link> to find a game or create one.
            </p>
            <div class="separator">
                <img class="bracket" src="~@/assets/celtic_bracket.png" />
                <span class="section-title">Screenshots</span>
                <img class="bracket flipped" src="~@/assets/celtic_bracket.png" />
            </div>
            <div class="gallery">
                <div class="screenshot-wrapper">
                    <img class="screenshot" src="~@/assets/screenshot_game.png" />
                    <div class="caption">The game board</div>
                </div>
                <div class="screenshot-wrapper">
                    <img class="screenshot" src="~@/assets/screenshot_close_up.png" />
                    <div class="caption">A close-up on the Marshal</div>
                </div>
                <div class="screenshot-wrapper">
                    <img class="screenshot" src="~@/assets/screenshot_2_player_game_state.png" />
                    <div class="caption">Another game in progress</div>
                </div>
                <div class="screenshot-wrapper">
                    <img class="screenshot" src="~@/assets/screenshot_4_player_game.png" />
                    <div class="caption">A 4-player game</div>
                </div>
                <div class="screenshot-wrapper">
                    <img class="screenshot" src="~@/assets/screenshot_unit_cards.png" />
                    <div class="caption">A view of the unit cards</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Home',
    data() {
        return {};
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .home {

        i {
            font-style: italic;
        }

        .content {
            font-size: 1.1em;
        }

        .gallery {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;

            .screenshot-wrapper {
                margin-bottom: 25px;
                box-shadow: 0px 1px 3px 2px $light-gray;
                background: $off-white;
                padding: 10px;

                .screenshot {
                    max-width: 100%;
                    height: auto;
                    width: auto;
                }

                .caption {
                    font-size: .8em;
                    text-align: center;
                }
            }
        }
    }

    @media only screen and (min-width: $screen-sm) {

        .home {

            .title-wrapper {

                .title {
                    font-size: 3.5em;
                    max-width: none;
                }
            }
        }
    }

</style>
